class OrderHelper {
  constructor() { }

  /**
   * Заполняет шаблон билета данными
   * @param $ticket
   * @param data {Object} - {
   *   sector or view_id,
   *   sid or id,
   *   event_id,
   *   row,
   *   col,
   *   price
   * }

   */

  insertDataToTicket($ticket, data) {
    const sector = data.sector || '';
    const sid = data.sid || data.id;
    const currentEventId = data.event_id;
    const priceId = data.price_view_id || data.price_id;
    const name = data.name || `Ряд ${data.row} место ${data.col}`;
    const ticketClassName = null;
    $ticket.find('.js-ticket-price').text(data.price !== undefined ? data.price : '');
    $ticket.find('.js-ticket-sector').text(sector);
    !data.is_pack && !data.hide ? $ticket.find('.js-ticket-place').text(name) : '';

    if (data.additionalTickets?.length > 0) {
      $ticket.find('.js-ticket-service')
        .html(`
          <svg width="16" height="16" aria-hidden="true" focusable="false">
              <use xlink:href="#service-added"></use>
          </svg>
          <span>
            Услуга добавлена
          </span>
        `)
        .addClass('additional-services__added-service')
        .attr('data-id', data.additionalTickets[0].id)
        .attr('data-uid', data.additionalTickets[0].uid)
        .attr('data-parent-id', data.uid)
        .css('display', 'block');
    } else if (data.additionalServices?.length > 0 && data.additionalTickets?.length === 0) {
      const $button = $('<button>')
        .addClass('btn-class js-additional-services')
        .html(`
          <svg width="16" height="16" aria-hidden="true" focusable="false">
              <use xlink:href="#service-add"></use>
          </svg>
          <span>
            Добавить услугу
          </span>
        `)
        .addClass('additional-services__add-service')
        .attr('data-parent-id', data.uid)
        .attr('data-order-id', data.order_id);

      const additionalServicesData = JSON.stringify(data.additionalServices);
      $button.attr('additional-services-data', additionalServicesData);

      $ticket.find('.js-ticket-service').append($button);
      $ticket.find('.js-ticket-service').css('display', 'block');
    }

    if (window.allowPriceIds.length > 0) {
      const loyalties = this.setPriceLoyalties(data);
      $ticket.find('.js-ticket-price-loyalties').append(loyalties);
    }

    $ticket
      .find('.tickets__item')
      .attr('data-place', sid)
      .attr('data-uid', data.uid)
      .attr('data-id', data.id)
      .attr('data-price-id', priceId)
      .attr('data-event', currentEventId)
      .attr('data-order-id', data.order_id)
      .addClass(ticketClassName);

    return $ticket;
  }

  setPriceLoyalties(currentItem) {
    const randomId = Date.now();
    const allowedLoyality = [
      {
        id: 0, name: 'Основной', price_view_id: 0, description: '',
      },
      ...(window.allowPriceIds || []),
    ];

    const loyaltyCategoryId = currentItem.loyalty_category_id || 0;
    const currentLoyality = allowedLoyality.find((item) => item.id === loyaltyCategoryId) ?? {};

    const CATEGORY_ICONS = {
      0: 'ticket-category',
      1: 'user-child',
      default: 'other-preferential-category',
    };

    const getCategoryIcon = (id) => CATEGORY_ICONS[id] || CATEGORY_ICONS.default;

    const template = (category) => {
      const isSelected = category.id === loyaltyCategoryId;
      return `
        <li class="dropdown__item">
          <label class="radio-custom price-category-select__item">
            <input 
              type="radio" 
              class="mr-2" 
              value="${category.price_view_id}" 
              ${isSelected ? 'checked' : ''} 
              data-name="${category.name}" 
              data-category-id="${category.id}"
              name="price_category_${randomId}"
            >
            <svg class="icon icon_user-child" width="17" height="20">
              <use xlink:href="#${getCategoryIcon(category.id)}"></use>
            </svg>
            ${category.name}
          </label>
        </li>`;
    };

    return `
      <div class="tickets__category">
        <div class="price-category-select dropdown" data-item-id="${loyaltyCategoryId}">
          <button 
            type="button" 
            class="dropdown__btn reset-btn ticket__category"
            id="dropdown__btn--${randomId}"
            aria-haspopup="true"
            aria-expanded="false"
            aria-controls="dropdown__menu--${randomId}"
          >
            <span class="price-category-select__selected-name">
              <svg class="icon" width="20" height="20">
                <use xlink:href="#${getCategoryIcon(loyaltyCategoryId)}"></use>
              </svg>
              ${currentLoyality.name || 'Неизвестно'}
            </span>
            <svg width="20" height="20" class="icon icon_down ml-1 dropdown__icon-down">
              <use xlink:href="#down"></use>
            </svg>
          </button>
          <div class="dropdown__menu" aria-hidden="false" id="dropdown__menu--${randomId}" aria-owns="dropdown__btn--${randomId}">
            <ul class="dropdown__list">
              ${allowedLoyality.map(template).join('')}
            </ul>
          </div>
        </div>
      </div>`;
  }
}

export const orderHelper = new OrderHelper();
